export let TypeToast;

(function (TypeToast) {
  TypeToast["ReqToastOpen"] = "REQ.TOAST.OPEN";
})(TypeToast || (TypeToast = {}));